<template>
  <div>
    <v-app-bar flat color="primary">
      <v-spacer></v-spacer>
      <img :src="`${publicPath}img/logo-white-small.png`" style="max-height: 26px; height: 100%" />
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container class="pt-6 pb-10">
      <div v-if="step == 1">
        <div class="mb-4 text-center font-weight-bold red--text">
          ช่องทางการขอรับเงินผลประโยชน์ตามกรมธรรม์<br />
          ผ่านบัญชีธนาคาร / ผ่านบัญชีพร้อมเพย์ (Prompt pay)
        </div>

        <step1></step1>
      </div>
      <div v-if="step == 2">
        <div class="mb-4 text-center font-weight-bold red--text">
          ช่องทางการขอรับเงินผลประโยชน์ตามกรมธรรม์
        </div>
        <step2></step2>
      </div>
      <div v-if="step == 3">
        <div class="mb-4 text-center font-weight-bold red--text">
          <template v-if="input && input.receive_type == 'prompt_pay'">
            แจ้งขอรับผลประโยชน์ตามกรมธรรม์ผ่าน<br />
            Prompt pay สมัครโดยใช้เลขที่บัตรประชาชน
          </template>
          <template v-else> แจ้งขอรับเงินผลประโยชน์ตามกรมธรรม์ <br />ผ่านบัญชีธนาคาร </template>
        </div>
        <step3></step3>
      </div>
    </v-container>
  </div>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";

export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    step() {
      return this.$store.state.step;
    },
    input() {
      return this.$store.state.input;
    },
  },
};
</script>

<style lang="scss" scoped></style>
